import Boto from 'components/corporatiu/Boto';
import styles from './preguntesfrequents.module.scss';
import Desplegable from 'components/corporatiu/Desplegable';
import Fila from 'components/corporatiu/Fila';
import Titol from 'components/corporatiu/Titol/Titol';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

const PreguntesFrequents = ({
    titol,
    preguntes,
    estil = 'trescat',
    tema,
    icona = 'mes',
    iconaOpen = 'menys',
    mostraIndex = false,
    showcontacta = false,
    className
}) => {
    const stylesPreguntesFrequents = clsx({
        [styles.preguntesfrequents]: true,
        [className]: !__isEmpty(className)
    });

    return (
        <Fila tipus='fixed' columnes={!__isEmpty(titol) ? '4_8' : '12'}>
            {!__isEmpty(titol) && <Titol titol={titol} tag='h2' tipus='gran' />}
            <div className={stylesPreguntesFrequents}>
                {preguntes?.map((pregunta, index) => (
                    <>
                        {!__isEmpty(pregunta.seccio) &&
                            (!__isEmpty(titol) ? (
                                <p className={styles.subtitol}>{pregunta.seccio}</p>
                            ) : (
                                <h2 className={styles.subtitol}>{pregunta.seccio}</h2>
                            ))}
                        {!__isEmpty(pregunta.enllac) && <a name={pregunta.enllac} className={styles.anchor}></a>}
                        <Desplegable
                            key={index}
                            estil={estil}
                            tema={tema}
                            icona={icona}
                            iconaOpen={iconaOpen}
                            titol={mostraIndex ? `${index + 1}- ${pregunta.titol}` : pregunta.titol}
                            tag='h3'
                        >
                            <div className={styles.resposta} dangerouslySetInnerHTML={{ __html: pregunta.resposta }} />
                        </Desplegable>
                    </>
                ))}
                {showcontacta && (
                    <div className={styles.notrobes}>
                        <span className={styles.titolnotrobes}>No trobes la resposta que busques?</span>
                        <Boto text='Contacta amb nosaltres' link='/atencio/' estil='negre' />
                    </div>
                )}
            </div>
        </Fila>
    );
};

export default PreguntesFrequents;
